import { useEffect } from 'react';
import { useParams, Link  } from 'react-router-dom';
import { Row, Col, ListGroup, Image, Card } from 'react-bootstrap';
import Message from '../components/Message';
import Loader from '../components/Loader';
import { useGetBillDetailsQuery } from '../slices/billsApiSlice';

const BillScreen = () => {
  const { id: billId } = useParams();

  const { data: bill, refetch, isLoading, error } = useGetBillDetailsQuery(billId);

  useEffect(() => {
    if (!bill) {
      refetch();
    }
  }, [bill, refetch]);

  return isLoading ? (
    <Loader />
  ) : error ? (
    <Message variant="danger">{error?.data?.message || error.error}</Message>
  ) : (
    <>
      <h1>Bill {bill?._id || 'N/A'}</h1>
      <Row>
        <Col md={8}>
          <ListGroup variant="flush">
            <ListGroup.Item>
                      
              <h2>Customer Details</h2>
              <Message>
              Your cart is empty <Link to="/house/HomeScreen">Go Back</Link>
              </Message>
              <p>
                <strong>Name: </strong> {bill?.customerDetails?.name || 'N/A'}
              </p>
              <p>
                <strong>Company: </strong> {bill?.customerDetails?.company || 'N/A'}
              </p>
              <p>
                <strong>Phone: </strong> {bill?.customerDetails?.telephone || 'N/A'}
              </p>
              <p>
                <strong>Address: </strong> {bill?.customerDetails?.address || 'N/A'}
              </p>
              <p>
                <strong>Serial: </strong> {bill?.customerDetails?.serialNumber || 'N/A'}
              </p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Bill Note</h2>
              <p>{bill?.note || 'No additional notes provided'}</p>
              <p>{bill?.username || 'No user name provided'}</p>
            </ListGroup.Item>

            <ListGroup.Item>
              <h2>Bill Items</h2>
              {bill?.billItems?.length === 0 ? (
                <Message>This bill has no items</Message>
              ) : (
                <ListGroup variant="flush">
                  {bill?.billItems?.map((item, index) => (
                    <ListGroup.Item key={index}>
                      <Row>
                        <Col md={1}>
                          <Image
                            src={item?.images?.[0] || 'https://via.placeholder.com/40'}
                            alt={item?.name || 'Unnamed'}
                            fluid
                            rounded
                          />
                        </Col>
                        <Col>
                          <strong>{item?.name || 'Unnamed'}</strong>
                        </Col>
                        <Col md={4}>
                          {item?.qty || 0} x ${item?.price || 0} = $
                          {(item?.qty || 0) * (item?.price || 0)}
                        </Col>
                        <Col md={4}>
                          {((item?.qty || 0) * (item?.price || 0) * 1.4).toFixed(0)}
                          
                        </Col>
                      </Row>
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </ListGroup.Item>
          </ListGroup>
        </Col>
        <Col md={4}>
          <Card>
            <ListGroup variant="flush">
              <ListGroup.Item>
                <h2>Bill Summary</h2>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Date</Col>
                  <Col>{bill?.date?.substring(0, 10) || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>TotalRev</Col>
                  <Col>${bill?.totalPrice || 0}</Col>
                </Row>
                <Row>
                  <Col>TotalInsu</Col>
                  <Col>${(bill?.totalInsu || 0).toFixed(0)}</Col>
                </Row>

              </ListGroup.Item>
              <ListGroup.Item>
                <Row>
                  <Col>Status</Col>
                  <Col>{bill?.status || 'N/A'}</Col>
                </Row>
              </ListGroup.Item>
            </ListGroup>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default BillScreen;